import React from "react";

const palette = {
  red: "#e53935",
  yellow: "#f6c344",
  green: "#43a047",
};

const StopLightCircle = ({ color, active = true, size = 26 }) => {
  return (
    <span
      style={{
        marginLeft: "10px",
        display: "inline-block",
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        backgroundColor: active ? palette[color] || "#bdbdbd" : "#bdbdbd",
        boxShadow: active ? "0 0 0 1px rgba(0,0,0,0.05)" : "none",
      }}
    />
  );
};

export default StopLightCircle;
